/**
 * Helper function to get authentication headers for API requests
 * Now uses Clerk session tokens instead of JWT
 * 
 * IMPORTANT: This function should be called from within a React component
 * that has access to Clerk context. Pass the getToken function from useAuth() hook.
 */
export async function getAuthHeaders(getToken?: () => Promise<string | null>): Promise<HeadersInit> {
  const headers: HeadersInit = {
    "Content-Type": "application/json",
  };

  // Get Clerk session token
  if (getToken) {
    try {
      const token = await getToken();
      if (token) {
        headers["Authorization"] = `Bearer ${token}`;
        // Log token prefix for debugging (first 20 chars only)
        if (process.env.NODE_ENV !== "production") {
          console.log("✅ Token retrieved:", token.substring(0, 20) + "...");
        }
      } else {
        console.warn("⚠️  getToken() returned null - user may not be authenticated");
      }
    } catch (error) {
      console.error("❌ Failed to get Clerk session token:", error);
    }
  } else {
    console.warn("⚠️  getToken function not provided");
    // Fallback: try to get from global Clerk instance
    try {
      const clerk = (window as any).Clerk;
      if (clerk) {
        const session = await clerk.session;
        if (session) {
          const token = await session.getToken();
          if (token) {
            headers["Authorization"] = `Bearer ${token}`;
            if (process.env.NODE_ENV !== "production") {
              console.log("✅ Token retrieved from window.Clerk:", token.substring(0, 20) + "...");
            }
          }
        }
      }
    } catch (error) {
      console.warn("Failed to get Clerk session token from window.Clerk:", error);
    }
  }

  return headers;
}

